import { create } from 'zustand'

import {
  getAdditionalDepreciationAccounts,
  getAdditionalDepreciation,
  saveAdditionalDepreciation,
  removeAdditionalDepreciation,
  getDetailedSummaryDepreciation,
  editDetailedSummaryDepreciation,
  getBigNumbersDepreciation,
  reverseWorkflowDepreciation,
  approvalWorkflowDepreciation,
  reversePreviewDepreciation,
  releasePreviewDepreciation
} from './provider'

import type { UseDepreciationProps } from './types'

export const useDepreciation = create<UseDepreciationProps>((set) => ({
  additionalDepreciationData: null,
  setAdditionalDepreciationData: (data) => set({ additionalDepreciationData: data }),

  additionalDepreciationQuery: null,

  isAdditionalDepreciationLoading: false,
  setIsAdditionalDepreciationLoading: (value) => set({ isAdditionalDepreciationLoading: value }),

  isAddEditAdditionalDepreciationLoading: false,
  setIsAddEditAdditionalDepreciationLoading: (value) => set({ isAddEditAdditionalDepreciationLoading: value }),

  isRemoveAdditionalDepreciationLoading: false,
  setIsRemoveAdditionalDepreciationLoading: (value) => set({ isRemoveAdditionalDepreciationLoading: value }),

  additionalDepreciationAccounts: [],
  isAdditionalDepreciationAccountsLoading: false,

  detailedSummaryDepreciationData: null,
  setDetailedSummaryDepreciationData: (data) => set({ detailedSummaryDepreciationData: data }),

  isDetailedSummaryDepreciationLoading: false,
  setIsDetailedSummaryDepreciationLoading: (value) => set({ isDetailedSummaryDepreciationLoading: value }),

  isEditDetailedSummaryDepreciationLoading: false,
  setIsEditDetailedSummaryDepreciationLoading: (value) => set({ isEditDetailedSummaryDepreciationLoading: value }),

  bigNumbersDepreciationData: null,
  setBigNumbersDepreciationData: (data) => set({ bigNumbersDepreciationData: data }),

  isBigNumbersDepreciationLoading: false,
  setIsBigNumbersDepreciationLoading: (value) => set({ isBigNumbersDepreciationLoading: value }),

  isReverseWorkflowDepreciationLoading: false,
  setIsReverseWorkflowDepreciationLoading: (value) => set({ isReverseWorkflowDepreciationLoading: value }),

  isApprovalWorkflowDepreciationLoading: false,
  setIsApprovalWorkflowDepreciationLoading: (value) => set({ isApprovalWorkflowDepreciationLoading: value }),

  isReversePreviewDepreciationLoading: false,
  setIsReversePreviewDepreciationLoading: (value) => set({ isReversePreviewDepreciationLoading: value }),

  isReleasePreviewDepreciationLoading: false,
  setIsReleasePreviewDepreciationLoading: (value) => set({ isReleasePreviewDepreciationLoading: value }),

  getAdditionalDepreciationAccounts,
  getAdditionalDepreciation,
  saveAdditionalDepreciation,
  removeAdditionalDepreciation,
  getDetailedSummaryDepreciation,
  editDetailedSummaryDepreciation,
  getBigNumbersDepreciation,
  reverseWorkflowDepreciation,
  approvalWorkflowDepreciation,
  reversePreviewDepreciation,
  releasePreviewDepreciation
}))
